import React from "react";
import "./VangalMapSection.css";

const VangalMapSection = () => {
  return (
    <section className="vf-map-wrapper anim anim-bottom">
      <div className="vf-map-container">
        <h2 className="vf-map-title">Find Us on the Map</h2>

        <div className="vf-map-frame">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5670.441835712692!2d78.14888678437508!3d11.281810502368364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babcf5d603cbaa9%3A0x2fbf6e50e2951a4d!2sVangal%20Dairy!5e0!3m2!1sen!2sin!4v1764941694672!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="vf-map-iframe"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default VangalMapSection;
